import { TestMessageViewer } from '../components'
import { useAccountContext } from '../contexts'
import { Layout } from '../layouts/Layout'

export function TestMessagePage() {
  const { selectedDevice } = useAccountContext()

  return (
    <Layout>
      <TestMessageViewer sigfoxId={selectedDevice} />
    </Layout>
  )
}
